import React, { useState, useEffect } from "react";
import { humanizeDate } from "../../helpers/DateHelper";

const LiveRelativeTime = ({ date, fallback, style, className }) => {
  const [displayTime, setDisplayTime] = useState(
    date ? humanizeDate(date) : fallback,
  );

  useEffect(() => {
    if (!date) {
      setDisplayTime(fallback);
      return;
    }

    const updateTime = () => {
      setDisplayTime(humanizeDate(date));
    };

    // Initial update
    updateTime();

    // Determine interval: if it's "seconds ago", update more frequently
    // For now, 30 seconds is a good balance
    const interval = setInterval(updateTime, 30000);

    return () => clearInterval(interval);
  }, [date, fallback]);

  return (
    <span style={style} className={className}>
      {displayTime}
    </span>
  );
};

export default LiveRelativeTime;
